import { createTrackingEvent } from '@/common/analytics/gtm/createTrackingEvent';
import { convertStringToGTMSlug } from '@/common/analytics/gtm/shared/convertStringToGTMSlug';
import { DefaultTrackPromotionEvent } from '@/common/analytics/gtm/shared/trackViewPromotion';
import { isRetinaDevice } from '@/common/utils/sharedUtils';
import { Category } from '@/modules/HomePage/components/Categories/Category.data';
import { HomepageConfig } from '@/modules/HomePage/HomePageConfig';

export const trackG4CategoryClick = (categoryTrackEvent: DefaultTrackPromotionEvent) => {
  createTrackingEvent({
    event: 'select_promotion',
    ecommerce: categoryTrackEvent,
  });
};

export const createCategoryTrackEvent = (
  cat: Category,
  position: number,
): DefaultTrackPromotionEvent => {
  return {
    promotion_id: `category|${HomepageConfig.analyticsGaName}|${convertStringToGTMSlug(cat.label)}`,
    promotion_name: cat.label,
    promotion_type: 'category',
    creative_name: cat.image,
    creative_slot: `category_grid|${position}`,
    creative_size: `${isRetinaDevice() ? 'retina' : 'standard'}`,
  };
};
